import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import IconSVG from 'svg-inline-react';
import ActionCreators from 'actions/ActionCreators';

import './ProgressBar.scss';

const SIZE = ['s', 'm', 'l']

class ProgressBar extends Component {

    static propTypes = {
        className: PropTypes.string,
        onChange: PropTypes.func,
        icon: PropTypes.string,
        description: PropTypes.string,
        sale: PropTypes.string,
        tip: PropTypes.any,
        tipSize: PropTypes.oneOf(SIZE),
        tipShow: PropTypes.bool,
        confirmed: PropTypes.bool,
        link: PropTypes.string,
        linkActive: PropTypes.bool,
        tipNumber: PropTypes.number,
    };

    static defaultProps = {
        tipSize: 's',
    }

    state = {
        animation: false,
    }

    componentWillReceiveProps = () => {
        this.setState({
            animation: true,
        })
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (
            nextProps.confirmed !== this.props.confirmed ||
            nextProps.tipShow !== this.props.tipShow
        );
    }

    _onChange = (event, value) => {
        if (this.props.onChange) {
            this.props.onChange(event, value);
        }
    }

    _onBarClick = (link) => {
        // Включить, если хотим чтобы бары были ссылками и по ним можно было вернуться
        // if (this.props.linkActive) {
        //     ActionCreators.setStage(this.props.link, this.props.location.query);
        // } else {
        //     return false;
        // }

        return false;
    }

    _onCloseTipClick = () => {
        ActionCreators.updateShowTips({
            ['tip' + this.props.tipNumber]: false,
        });
        this._onChange();
    }

    render() {
        var {className, onChange, icon, description, sale, tip, ...props} = this.props;
        var confirmed = this.props.confirmed;

        var progressBarClass = classNames(
            'ProgressBar',
            className,
            {
                'ProgressBar--confirmed': confirmed,
                // Включить, если хотим чтобы бары были ссылками и по ним можно было вернуться
                // 'ProgressBar--linkActive': this.props.linkActive,
                'ProgressBar--animation': this.state.animation,
            }
        );
        var iconClass = classNames(
            'ProgressBar-icon',
            `ProgressBar-icon--${icon}`
        );

        var tooltip = '';
        if (this.props.tip) {
            var progressBarTipClass = classNames(
                'ProgressBar-tip',
                `ProgressBar-tip--${this.props.tipSize}`,
                {'ProgressBar-tip--show': this.props.tipShow}
            );

            tooltip = (
                <div className={ progressBarTipClass }>
                    <div className="ProgressBar-tipContent">
                        {this.props.tip}
                    </div>
                    <IconSVG className="ProgressBar-tipClose"
                        onClick={this._onCloseTipClick}
                        src={require(`!svg-inline!./close.svg`)}
                        title='Закрыть подсказку'/>
                </div>
            )
        };

        return (
            <div className={ progressBarClass }
                onClick={this._onBarClick}>
                <div className="ProgressBar-content">
                    <IconSVG className={iconClass}
                        src={require(`!svg-inline!./${icon}.svg`)}
                        title={description}/>
                    <span className="ProgressBar-description">{description}</span>
                    <span className="ProgressBar-sale">{sale}</span>
                    <div className="ProgressBar-borderRight"/>
                </div>
                <div className="ProgressBar-progress"/>
                { tooltip }
            </div>
        );
    }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./client/components/ProgressBarPane/ProgressBar.js